import React from 'react';
import { useSelector } from 'react-redux';

import '../styles/header.css';
import { logo ,logoDark } from 'images';

export const Header = () => {
  
    const isImpaired = useSelector(state => state.layout.isImpaired);

    return (
        <div>
            <div className="logo-image-wrapper">
                <a href="/dash">
                    <img className="logo-image" src={ isImpaired ? logoDark : logo}/>
                </a>
            </div>
            <div className={ isImpaired ? "grayTrack-disability" : "grayTrack"}>
                <div className="container-fluid">
                    <a className="link-padding" href="/dash">
                        <span className="text-white strong">e-Pristojbe</span>
                    </a>
                </div>
            </div>
        </div>
  )
}

